class EventListener {
    callback: Function;

    priority: number = 0;
}
export = EventListener;
